// extracted by mini-css-extract-plugin
export default {"header":"styles_header__OZ2vh","titleWrapper":"styles_titleWrapper__IrkE5","drawerHeaderIcon":"styles_drawerHeaderIcon__vzHIi"};